import React from "react";
import Carousel from "../Component/Carousel";

const Gallery = () => {
  return (
    <>
    <Carousel/>
    </>
    // <div className="">
    //   {/* content */}
    //   <Carousel />
    // </div>
  );
};
export default Gallery;
